import { getApiBase } from "./config";

export class ApiError extends Error {
  constructor(message: string, public status?: number) {
    super(message);
  }
}

export async function apiFetch(path: string, init?: RequestInit): Promise<Response> {
  const base = getApiBase();
  const url = path.startsWith("http") ? path : `${base}${path}`;
  return fetch(url, { ...init, credentials: "include" });
}

export async function apiJson<T = unknown>(path: string, init?: RequestInit): Promise<T> {
  const res = await apiFetch(path, init);
  if (!res.ok) {
    const body = await res.json().catch(() => ({ error: `HTTP ${res.status}` }));
    throw new ApiError((body as { error?: string }).error || `HTTP ${res.status}`, res.status);
  }
  return (await res.json()) as T;
}

export async function apiPostJson<T = unknown>(path: string, body: unknown): Promise<T> {
  return apiJson<T>(path, {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify(body),
  });
}

export async function apiPatchJson<T = unknown>(path: string, body: unknown): Promise<T> {
  return apiJson<T>(path, {
    method: "PATCH",
    headers: { "content-type": "application/json" },
    body: JSON.stringify(body),
  });
}

export async function apiDelete(path: string): Promise<void> {
  const res = await apiFetch(path, { method: "DELETE" });
  if (!res.ok) {
    const body = await res.json().catch(() => ({ error: `HTTP ${res.status}` }));
    throw new ApiError((body as { error?: string }).error || `HTTP ${res.status}`, res.status);
  }
}

export async function pingBackend(): Promise<{ ok: boolean; tools?: number; error?: string }> {
  try {
    const res = await apiFetch("/healthz");
    if (!res.ok) return { ok: false, error: `HTTP ${res.status}` };
    const t = await apiJson<{ names?: string[] }>("/tools").catch(() => ({ names: [] }));
    return { ok: true, tools: t.names?.length ?? 0 };
  } catch {
    return { ok: false, error: "unreachable" };
  }
}
